<template>
  <my-drawer
    @hideMask="$emit('hideMaskForDrawer')"
    :drawerFlag="drawerFlag"
    backgroundColorForSon="rgba(255, 255, 255, .3)"
  >
    <div class="player_outer_box">
      <!-- 原本是使用自定义播放器 -->
      <!-- <custom-video :options="options" /> -->
      <!-- 现在使用阿里云播放器 -->
      <div id="J_prismPlayer"></div>
    </div>
  </my-drawer>
</template>

<script>
export default {
  components: {
    'my-drawer': () => import('../../components/my_drawer')
  },
  props: {
    drawerFlag: {
      type: Boolean,
      default: false
    },
    drawerVideoSrc: {
      type: String,
      default: ''
    }
  },
  watch: {
    drawerFlag: {
      handler(newVal) {
        if (!newVal) return
        if (!this.drawerVideoSrc) return
        this.initAliplayerVideo(this.drawerVideoSrc)
      },
      immediate: true
    }
  },
  data() {
    return {
      // 自定义视频：
      // options: {
      //   src: '',
      //   poster: '',
      //   objectFit: 'auto',
      //   // refresh: true,
      //   time: true,
      //   // definition: true,
      //   // definitionList: [
      //   //   {
      //   //     key: 'superDefinition',
      //   //     value: '超清'
      //   //   },
      //   //   {
      //   //     key: 'highDefinition',
      //   //     value: '高清'
      //   //   },
      //   //   {
      //   //     key: 'fluency',
      //   //     value: '流畅'
      //   //   }
      //   // ],
      //   // definitionActive: '高清',
      //   playbackRate: true,
      //   section: true,
      //   sectionList: [],
      //   sectionActive: '',
      //   volume: true,
      //   browserFullScreen: true,
      //   fullscreen: true,
      //   currentTime: 0
      // }
    }
  },
  methods: {
    // 初始化阿里播放器：
    initAliplayerVideo(url) {
      const props = {
        id: 'J_prismPlayer',
        width: '100%',
        height: '100%',
        autoplay: false,
        preload: true,
        controlBarVisibility: 'always',
        useH5Prism: true,
        playsinline: true,
        isLive: false,
        language: 'zh-cn',
        // source: 'https://api.dogecloud.com/player/get.mp4?vcode=5ac682e6f8231991&userId=17&ext=.mp4', // 播放地址
        // source: 'https://bitdash-a.akamaihd.net/content/sintel/hls/playlist.m3u8', // 播放地址
        // cover: 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202209/295eedc2dcb54965b1fe17e64b352d95.png', // 封面地址
        source: '',
        cover: '',
        components: [],
        skinLayout: [
          // { name: "bigPlayButton", align: "blabs", x: 30, y: 80 },
          { name: 'bigPlayButton', align: 'cc' },
          { name: 'H5Loading', align: 'cc' },
          // {name: "errorDisplay", align: "tlabs", x: 0, y: 0},
          { name: 'infoDisplay', align: 'cc' },
          {
            name: 'controlBar',
            align: 'blabs',
            x: 0,
            y: 0,
            children: [
              { name: 'progress', align: 'blabs', x: 0, y: 44 },
              { name: 'playButton', align: 'tl', x: 15, y: 14 },
              { name: 'timeDisplay', align: 'tl', x: 10, y: 9 },
              { name: 'fullScreenButton', align: 'tr', x: 10, y: 14 },
              // { name: "subtitle", align: "tr", x:15, y:14 },
              { name: 'setting', align: 'tr', x: 15, y: 14 },
              { name: 'volume', align: 'tr', x: 12, y: 12 }
            ]
          }
        ]
      }
      this.$nextTick(() => {
        this.playerForAliplayer = new Aliplayer(props, function (playerForAliplayer) {})
        url && this.playerForAliplayer.loadByUrl(url)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin verticalAndCrosswiseCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}
.player_outer_box {
  height: 100%;
  padding: 20px;
  border-radius: 20px 20px 0 0;
  position: relative;
  overflow: hidden;
  background-color: #000;
}
</style>
